export default {
  state: {
    auth: {result: '', token: null}
  },

  mutations: {
    updateAuth(state, auth) {
      state.auth = auth;
    }
  },

  actions: {
    async login({ commit }, { user, password, locale }) {
      try {
        const response = await this._vm.$http.post('login', {
          login: {
            user,
            password,
            locale
          }
        });
        commit('updateAuth', response.data);
      } catch (error) {
        console.log(error);
      }
    },
    logout({ commit }) {
      commit('updateAuth', { result: '', token: null });
    }
  },

  getters: {
    auth(state) {
      return state.auth;
    }
  }
};
